import { createAction, handleActions } from 'redux-actions';
import produce from 'immer';
import set from 'lodash/set';
import get from 'lodash/get';

const CHANGE_OPTIONS = 'escrow-v2.options/CHANGE_OPTIONS';
const changeOptions = createAction(CHANGE_OPTIONS);

const initialState = {
	carId: null,
	carAdvertisingPrice: 0,
	estimateInfo: null,
	hasWarranty: null,
	warrantyList: null,
	selectedPayment: null,
	selectedWarranty: null,
	redirectURL: '',
	backURL: '',
	applicationUuid: '',
	encarpayInfo: null,
};

export const actions = {
	changeOptions,
};

export default handleActions(
	{
		[CHANGE_OPTIONS]: (state, action) =>
			produce(state, (draft) => {
				const values = action.payload;

				Object.keys(values).forEach((key) => {
					set(draft, key, get(values, key));
				});
			}),
	},
	initialState,
);
